import { DataLoader } from "../utils/dataLoader.js";

export class SoundDesign extends DataLoader {
  static KEY_SOUND = "sound";
  static KEY_POSSOUND = "positionalsound";

  /**
   * Construct a race design
   */
  constructor() {
    super("", "", "");

    this.sound = null;
    this.positionalsound = null;
  }

  /**
   * Receive loaded data
   * @param {Object} data The loaded data
   */
  receiveData(data) {
    if (data.hasOwnProperty(SoundDesign.KEY_SOUND))
      this.sound = data[SoundDesign.KEY_SOUND];

    if (data.hasOwnProperty(SoundDesign.KEY_POSSOUND))
      this.positionalsound = data[SoundDesign.KEY_POSSOUND];
  }
}
